// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING';

export const FETCH_LIVE_CONVERSATION_LISTING = 'FETCH_LIVE_CONVERSATION_LISTING';

export const FETCH_LIVE_CHAT_LISTING = 'FETCH_LIVE_CHAT_LISTING';

export const FETCH_TEAM_LISTING = 'FETCH_TEAM_LISTING';

export const FETCH_ASSIGN_LISTING = 'FETCH_ASSIGN_LISTING';

export const FETCH_LABEL_LISTING = 'FETCH_LABEL_LISTING';

export const LEAD_SELECTED_DATA = 'LEAD_SELECTED_DATA'; 

export const FETCH_CANNED_LISTING = 'FETCH_CANNED_LISTING';













